export default __webpack_public_path__ + "static/media/ZM.79cd9062.svg";